import React, { useState, useEffect } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import CustomTable from "../../organisms/CustomTable";
import Button from "../../atoms/Button";
import { retrieveBids } from "../../../utils/API/retrieveBidsGetData";
import { cancelBids } from "../../../utils/API/cancelbid";
import CounterComponent from "../../organisms/Counter";
import AcceptPopUp from "../AcceptPopUp";
import Cancelbid from "../CancelBid";
import { acceptBid } from "../../../utils/API/acceptbid";
import toast from "react-hot-toast";
import { Skeleton } from "antd";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";

const ViewBid = ({
  open,
  onCancel,
  selectedRowData,
  selectedColumns,
  projectId,
  ViewBidClose,
}) => {
  const dispatch = useDispatch();
  const [isAcceptPopUpOpen, setAcceptPopUpOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [BidData, setBidData] = useState([]);
  const [isViewCounterOpen, setViewCounterOpen] = useState(false);
  const [isCounterPriceOpen, setCounterPriceOpen] = useState(false);
  const [isCancelBidSuccess, setCancelBidSuccess] = useState(false);
  const [isCancelBidOpen, setCancelBidOpen] = useState(false);
  const [bidId, setBidId] = useState(null);
  const [counterData, setCounterData] = useState(null);

  const ActionButtons = ({
    onAcceptClick,
    onCounterClick,
    onCancelBidClick,
    bidId,
    number_Of_Credits,
    bidAmount,
    //
  }) => {
    return (
      <>
        <div className="flex gap-x-3 ">
          <Button
            color={"blue"}
            varient={"secondary"}
            onClick={() => {
              onAcceptClick(bidId);
            }}
            className={
              "text-white w-[4.3rem] text-[0.56rem] h-[1.875rem] font-medium"
            }
          >
            <div className="flex justify-center">
              {isLoading ? <LoadingOutlined /> : "Accept"}
            </div>
          </Button>
          <Button
            varient={"primary"}
            onClick={() => {
              onCounterClick(bidId, number_Of_Credits, bidAmount);
            }}
            className={
              " w-[4.3rem] text-[0.56rem] h-[1.875rem] font-medium border border-blue-800  text-blue-800  bg-blue-500 bg-opacity-25"
            }
          >
            Counter
          </Button>

          <Button
            varient={"secondary"}
            onClick={() => onCancelBidClick(bidId)}
            className={
              " w-[4.3rem] text-[0.56rem] h-[1.875rem] font-medium border border-red-800 text-red-700 bg-red-100 bg-opacity-30"
            }
          >
            Cancel
          </Button>
        </div>
      </>
    );
  };

  const headerData = [
    "Bid Id",
    "Bidder Name",
    "No.of Credits",
    "Bid Price",
    "Actions",
  ];
  const transformData = (data) => {
    return data.map((project) => {
      return [
        project.bid_id,
        project.userName,
        project.number_Of_Credits,
        project.bidAmount,

        <ActionButtons
          bidId={project.bidId}
          number_Of_Credits={project.number_Of_Credits}
          bidAmount={project.bidAmount}
          onAcceptClick={() => onAcceptClick(project.bidId)}
          onCounterClick={() =>
            handleViewCounterOk(
              project.bidId,
              project.number_Of_Credits,
              project.bidAmount
            )
          }
          onCancelBidClick={() => handleCancelBidOk(project.bidId)}
        />,
        setBidId(project.bidId),
      ];
    }, []);
  };

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        setIsLoading(true);
        if (projectId) {
          const data = await retrieveBids(projectId, dispatch);
          setBidData(transformData(data));
        }
      } catch (error) {
        console.error("Error fetching bids:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjectData();
  }, [projectId, open]);

  const onAcceptClick = async (bidId) => {
    try {
      setIsLoading(true);
      const res = await acceptBid(bidId, dispatch);
      setAcceptPopUpOpen(true);
      const data = await retrieveBids(projectId, dispatch);
      if (data) {
        setBidData(transformData(data));
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewCounterCancel = () => {
    setViewCounterOpen(false);
  };

  const handleViewCounterOk = (bidId, number_Of_Credits, bidAmount) => {
    setViewCounterOpen(true);
    setBidId(bidId);
    setCounterData({ number_Of_Credits, bidAmount });
  };

  const handleCounterPriceOk = () => {
    setViewCounterOpen(false);
    setCounterPriceOpen(true);
  };

  const handleCancelbidSuccessClose = async () => {
    await setCancelBidSuccess(false);
    ViewBidClose();
  };

  const handleCancelBidOk = (bidId) => {
    setCancelBidOpen(true);
    setBidId(bidId);
  };
  const handleCancelBidCancel = () => {
    setCancelBidOpen(false);
  };

  const handleCancelBidSuccess = async () => {
    try {
      setCancelBidSuccess(true);
      setCancelBidOpen(false);
      const data = await retrieveBids(projectId, dispatch);
      if (data) {
        setBidData(transformData(data));
      }
    } catch (error) {
      toast.error("Error cancelling bid");
    }
  };

  return (
    <DiaglogBox open={open} onCancel={onCancel} width={833}>
      <div className="bg-greyLight-100 flex h-96">
        <div className="w-full">
          <div className="bg-white ml-8 rounded-3xl pt-12">
            {isLoading ? (
              <>
                <CustomTable data={[]} headerData={headerData} />
                <div className="flex flex-col gap-y-4 p-4">
                  <Skeleton.Button block={true} active={true} />
                  <Skeleton.Button block={true} active={true} />
                </div>
              </>
            ) : (
              <CustomTable
                headerData={headerData}
                data={
                  Array.isArray(BidData)
                    ? BidData.map((biddata) => Object.values(biddata))
                    : []
                }
                bottomLine={false}
              />
            )}
          </div>
        </div>

        <AcceptPopUp
          open={isAcceptPopUpOpen}
          onCancel={async () => {
            await setAcceptPopUpOpen(false);
            ViewBidClose();
          }}
          onOk={async () => {
            await setAcceptPopUpOpen(false);
            ViewBidClose();
          }}
          title="Thanks for accepting the bid"
          okButtonText="Go back"
          statusType="Payment link sent. Once buyer pays, we'll notify you and provide details for credit transfer or retire. Check History tab for updates."
          isRequiredColor="green"
          isRequiredCancelButton={false}
          width={400}
        />

        <CounterComponent
          isOpen={isViewCounterOpen}
          onCancel={handleViewCounterCancel}
          onOk={handleViewCounterOk}
          onCounterPriceOk={handleCounterPriceOk}
          selectedRowData={selectedRowData}
          selectedColumns={selectedColumns}
          bidId={bidId}
          counterData={counterData}
        />

        <AcceptPopUp
          open={isCounterPriceOpen}
          onCancel={async () => {
            await setCounterPriceOpen(false);
            ViewBidClose(); // Close ViewBid popup as well
          }}
          onOk={async () => {
            await setCounterPriceOpen(false);
            ViewBidClose();
          }}
          title="Price re-quoted Successfully!"
          okButtonText="Go back"
          isRequiredStatus={false}
          isRequiredColor="green"
          isRequiredCancelButton={false}
          width={400}
        />
        <AcceptPopUp
          open={isCancelBidSuccess}
          onCancel={handleCancelbidSuccessClose}
          onOk={handleCancelbidSuccessClose}
          title="Bid canceled Successfully !!!"
          okButtonText="Go Back"
          isRequiredStatus={false}
          isRequiredCancelButton={false}
          isRequiredColor="red"
          width={400}
          bidId={bidId}
        />
        <Cancelbid
          open={isCancelBidOpen}
          onCancel={handleCancelBidCancel}
          onOk={handleCancelBidSuccess}
          bidId={bidId}
          viewBidOption={true}
        />
      </div>
    </DiaglogBox>
  );
};

export default ViewBid;
